import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'no-birthday',
  templateUrl: './no-birthday.component.html',
  styleUrls: ['./no-birthday.component.scss'],
})
export class NoBirthdayComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
